import React from "react";
import {
  Container,
  Paper,
  Typography,
  Grid,
  Tooltip,
  Button,
} from "@mui/material";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import DownloadIcon from "@mui/icons-material/Download";
import download from "downloadjs";
import { DownloadPortalGuideService } from "../../services/PortalGuideService";
import useGlobalState from "../../Context";
              
const PortalGuide = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }, dispatch] = useGlobalState();
  const loggedInUserRole = auth.ldapParam.role;
  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 11, ml:3 }}>
      <Typography align="left" sx={{ mr: "auto", color: "#003f93",  mb:3}} variant="h6">
              Portal Guide
            </Typography>
        <Paper elevation={3} sx={{ width: "97%", overflow: "hidden" }} display="flex">
          <Grid item xs={3} md={3} sx={{ ml: 2 }}>
            
            <Tooltip title="Download Portal Guide">
              <Button
                variant="contained"
                className="button-primary-alt-contained"
                startIcon={<DownloadIcon />}
                sx={{ ml: 1, mb: 5, mt:5 }}
                onClick={async () => {
                  try {
                    setLoading(true);
                    const response = await DownloadPortalGuideService(
                      loggedInUserRole
                    );
                    const content = response.headers["content-type"];
                    download(response.data, "User Portal.pdf", content);
                  } catch (err) {
                    showNotification("Error", "Failed To Fetch");
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                Download
              </Button>
            </Tooltip>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default PortalGuide;
